import butLogo from "@/assets/but-logo.png";
import bvLogo from "@/assets/bv-logo.png";
import confoLogo from "@/assets/confo-logo.png";
import { BUT_STORES } from "@/data/butStores";
import { CONFO_STORES } from "@/data/confoStores";

const tenants = {
  but: {
    name: "BUT",
    logo: butLogo,
    stores: BUT_STORES,
    defaultStoreExternalId: "ESTALY_BUT_LEADS",
    features: {
      advisoryDuty: true,
    },
  },
  confo: {
    name: "Conforama",
    logo: confoLogo,
    // Wide logo (6:1): a smaller height keeps the header balanced
    logoClass: "h-6",
    stores: CONFO_STORES,
    features: {
      advisoryDuty: true,
      consentCode: true,
      urlPrefill: true,
    },
  },
  bv: {
    name: "Bureau Vallée",
    logo: bvLogo,
    defaultStoreExternalId: "BV",
    features: {
      advisoryDuty: true,
    },
  },
};

export function getTenantSlug() {
  if (process.env.NODE_ENV === "development") {
    const params = new URLSearchParams(window.location.search);
    if (params.get("tenant")) return params.get("tenant");
  }
  const host = window.location.hostname;
  return host.split(".")[0];
}

export function getTenantConfig() {
  const slug = getTenantSlug();
  return tenants[slug] || null;
}
